var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon-arrow-left",attrs:{"aria-hidden":"true","tabindex":"-1","role":"presentation","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"#000000","d":"M23.5,26.984L21.883,28.5L8.5,16L21.883,3.5L23.5,5.009L11.742,16L23.5,26.984z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }